/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isnonblocking2Inputs */

const en__field_isnonblocking2 = /** @type {(inputs: _Field_Isnonblocking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does not nlock other workshops`)
};

const de__field_isnonblocking2 = /** @type {(inputs: _Field_Isnonblocking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockiert keine anderen Workshops`)
};

/**
* | output |
* | --- |
* | "Does not nlock other workshops" |
*
* @param {_Field_Isnonblocking2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_isnonblocking2 = /** @type {((inputs?: _Field_Isnonblocking2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isnonblocking2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_isnonblocking2(inputs)
	return de__field_isnonblocking2(inputs)
});
export { _field_isnonblocking2 as "_field_isNonBlocking" }